module.exports = __webpack_public_path__ + "img/bg-section-02-mobile.a0d0323c.svg";